export default __webpack_public_path__ + "static/media/undraw_jewelry_iima.5fb37061.svg";